import { useAuthInfiniteList } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { AdditionalApi } from 'api';
import { IAdditional, SearchAdditionalFilterType } from 'types';
import { KEY } from './keys';

function useGetInfinite(filter: SearchAdditionalFilterType, size = 30) {
  return useAuthInfiniteList<IAdditional>(
    [...getQueryKeys([KEY]).lists(), 'infinite', { ...filter, size }],
    (page) => AdditionalApi.getAll({ ...filter, page, size }),
  );
}

export default useGetInfinite;
